import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UsersState } from 'types';

export const initialState: UsersState = {
  loading: false,
  usersList: [],
  reset: false
};

const slice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsersList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.reset = false;
      state.usersList = payload || [];
    },
    reset: (state) => {
      state.reset = true
    }
  }
});

export const { setUsersList, reset } = slice.actions;

export default slice.reducer;
